<template>
  <v-dialog :model-value="dialogActive" max-width="600px" persistent scrollable>
    <v-card class="dialog-card">
      <v-card-title>
        <span class="headline">{{getDialogTitle()}}</span>
      </v-card-title>
      <div v-if="hasPermission('catalog.locations.create')" class="d-flex flex-wrap ga-2 px-6 pb-3">
        <v-btn type="button" color="primary" variant="text" min-height="48" :disabled="saving"
          @click="locationOpen = true">
          <v-icon start>add</v-icon>Agregar lugar
        </v-btn>
      </div>
      <v-card-text>
        <v-alert v-if="saveError" type="error" variant="tonal" class="mb-4">{{ saveError }}</v-alert>
        <v-alert v-if="locationsError" type="error" variant="tonal" class="mb-4">
          {{ locationsError }}
          <v-btn variant="text" min-height="48" :loading="loadingLocations" @click="loadLocations">Reintentar</v-btn>
        </v-alert>
        <v-form ref="form" v-model="valid" validate-on="lazy" :disabled="saving" @submit.prevent="save">
          <v-text-field
            label="Nombre"
            v-model="editedItem.name"
            :rules="[rules.requiredFieldRule]">
          </v-text-field>
          <v-select label="Responsabilidad ante el IVA"
            v-model="editedItem.responsibleType"
            item-title="description"
            :items="getResposibleType" return-object
            :rules="[rules.requiredFieldRule]">
          </v-select>
          <v-select label="Lugar"
            v-model="editedItem.location"
            item-title="name"
            item-value="id"
            :hint="getLocationDescription"
            persistent-hint
            :loading="loadingLocations"
            :items="companyLocations" return-object >
          </v-select>
          <v-text-field
            label="CUIT"
            v-model="editedItem.cuit" mask="##-########-#"
            :rules="[rules.requiredFieldRule, rules.cuit]">
          </v-text-field>
          <v-text-field
            label="Telefono"
            v-model="editedItem.phone">
          </v-text-field>
          <v-text-field label="E-Mail" v-model="editedItem.mail"
          :rules="[rules.email]">
          </v-text-field>
          <v-textarea class="pt-2"
            label="Observaciones"
            v-model="editedItem.obs"
            auto-grow box rows="3">
          </v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" min-height="48" :disabled="saving" @click="close()">Cancelar</v-btn>
        <v-btn v-if="canSave" color="primary" min-height="48" :loading="saving" @click="save()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <location-editor v-if="dialogActive && locationOpen && hasPermission('catalog.locations.create')" v-model="locationOpen"
    preset-type="OFICINA" @saved="editedItem.location = $event" />
</template>
<script>
import { mapGetters } from 'vuex'
import CatalogEditor from '../Common/CatalogEditor'
import LocationEditor from '../Location/AddEditLocationForm.vue'
export default {
  name: 'AddEditCompanyForm',
  mixins: [CatalogEditor],
  components: { LocationEditor },
  props: {
    formTitle: String
  },
  data: () => ({
    valid: true,
    locationOpen: false,
    loadingLocations: false,
    locationsError: '',
    catalogPermission: 'catalog.companies',
    catalogModule: 'companyModule',
    catalogSaveAction: 'saveCompany',
    rules: {
      requiredFieldRule: v => !!v || 'Campo requerido.',
      cuit: value => {
        if (value) {
          return (value.length === 11 || 'CUIT Invalido.')
        }
        return false
      },
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (value === '' || pattern.test(value)) || 'E-Mail Invalido.'
      }
    },
    editedItem: {
      id: -1,
      name: '',
      cuit: '',
      location: null,
      responsibleType: null,
      phone: '',
      mail: '',
      obs: ''
    },
    defaultItem: {
      id: -1,
      name: '',
      cuit: '',
      location: null,
      responsibleType: null,
      phone: '',
      mail: '',
      obs: ''
    }
  }),
  computed: {
    ...mapGetters('companyModule', ['isDialogActived', 'getSelectedItem', 'getResposibleType']),
    ...mapGetters('locationModule', ['getBaseLocations']),
    currentItem: function () {
      return this.$store.getters['companyModule/getSelectedItem']
    },
    companyLocations () {
      const selected = this.editedItem.location
      return selected?.id && !this.getBaseLocations.some(item => item.id === selected.id)
        ? [...this.getBaseLocations, selected] : this.getBaseLocations
    },
    getLocationDescription () {
      let locationDesc = ''
      if (this.editedItem.location && this.editedItem.location.name) {
        let { address, city } = this.editedItem.location
        locationDesc = city ? `${address || ''} (${city})` : (address || '')
      }
      return locationDesc
    }
  },
  created () {
    this.$store.dispatch('companyModule/getResposibleType')
  },
  watch: {
    dialogActive (active) {
      if (!active) this.locationOpen = false
    }
  },
  methods: {
    initializeEditor () {
      const item = this.modelValue === undefined && this.currentItem.id > 0 ? this.currentItem : {}
      this.editedItem = JSON.parse(JSON.stringify({ ...this.defaultItem, ...item }))
      this.loadLocations()
    },
    async loadLocations () {
      if (this.loadingLocations) return
      this.loadingLocations = true
      this.locationsError = ''
      try {
        await this.$store.dispatch('locationModule/getBaseLocations', { rejectOnError: true })
      } catch {
        this.locationsError = 'No se pudieron cargar los lugares. Puede volver a intentar.'
      } finally {
        this.loadingLocations = false
      }
    },

    getDialogTitle () {
      let dialogTitle
      if (this.editedItem.id > 0) {
        dialogTitle = `Editando Entidad Comercial: ${this.editedItem.name}`
      } else {
        dialogTitle = `Agregar Entidad Comercial`
      }
      return dialogTitle
    }
  }
}
</script>
